import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import sections from 'src/styles/sections';
import breakpointsFunc from 'src/styles/breakpointsFunc';
import helpers from 'src/styles/helpers';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({
  discountRow: {
    '& td': {
      color: '#2E7D32',
      fontWeight: 600
    }
  }
}, sections), helpers), {}, {
  cardWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  address: {
    display: 'flex',
    alignItems: 'center',
    '& .MuiSvgIcon-root': {
      marginRight: '20px'
    }
  },
  filterBar: {
    display: 'flex',
    [breakpointsFunc.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    }
  },
  lgField: {
    minWidth: '500px',
    marginRight: '10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      minWidth: '100%',
      marginRight: '0',
      marginBottom: '20px'
    }
  },
  field: {
    '& + &': {
      marginLeft: '10px'
    }
  },
  datePicker: {
    margin: '0 10px',
    [breakpointsFunc.breakpoints.down('md')]: {
      margin: '20px 0'
    }
  },
  accordion: {
    boxShadow: 'none',
    marginTop: '0 !important',
    '& + &': {
      marginTop: '0'
    },
    '&.Mui-expanded': {
      margin: '0'
    },
    '& .MuiAccordionSummary-expandIconWrapper': {
      transform: 'rotate(90deg)',
      marginRight: '0',
      '&.Mui-expanded': {
        transform: 'rotate(-90deg)'
      }
    }
  },
  accordionSummary: {
    padding: '32px',
    flexDirection: 'row',
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      alignItems: 'center'
    },
    '& .MuiAccordionSummary-expandIconWrapper path': {
      fill: palette.shades[700]
    }
  },
  dataGrid: {
    boxShadow: 'none',
    backgroundColor: palette.shades[200]
  },
  cellContent: {
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    padding: '5px 10px'
  },
  cellLeft: {
    width: '100%'
  },
  buildingsList: {
    '& .MuiPaper-root': {
      zIndex: '9',
      '& + .MuiPaper-root': {
        marginTop: '10px'
      }
    }
  },
  collapseTable: {
    padding: '0',
    borderBottom: '0',
    '&:first-of-type': {
      paddingLeft: '0'
    },
    '&:last-of-type': {
      paddingRight: '0'
    },
    '& .MuiTableRow-root': {
      backgroundColor: palette.shades[200],
      '& + .MuiTableRow-root': {
        borderTop: "1px solid ".concat(palette.shades[300])
      }
    }
  },
  collapseIsOpen: {
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  addressCell: {
    width: '400px'
  },
  arrow: {
    transition: "all ".concat(palette.transitions.short)
  },
  arrowIsOpen: {
    transform: 'rotate(-180deg)'
  },
  notFound: {
    fontSize: '18px',
    marginTop: '64px',
    textAlign: 'center',
    color: palette.shades[600]
  },
  loader: {
    marginTop: '42px'
  },
  tabsWrapper: {
    zIndex: 10,
    marginTop: '32px',
    padding: '0 32px',
    position: 'relative',
    backgroundColor: palette.shades[100],
    borderBottom: "1px solid ".concat(palette.shades[300])
  },
  paginationControllers: {
    display: 'flex',
    margin: '0 -6px',
    marginTop: '12px',
    '& .MuiButton-root': {
      width: '100%',
      margin: '0 6px'
    }
  }
}));
export default useStyles;